// extracted by mini-css-extract-plugin
module.exports = {"imageSlider":"CardSlider-module--imageSlider--1Xjb8","slideItem":"CardSlider-module--slideItem--3IYCo","copySlider":"CardSlider-module--copySlider--4k5RT"};